import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=4a9d5b90&scoped=true"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"
import style0 from "./HomeComponent.vue?vue&type=style&index=0&id=4a9d5b90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d5b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9d5b90')) {
      api.createRecord('4a9d5b90', component.options)
    } else {
      api.reload('4a9d5b90', component.options)
    }
    module.hot.accept("./HomeComponent.vue?vue&type=template&id=4a9d5b90&scoped=true", function () {
      api.rerender('4a9d5b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/default/HomeComponent.vue"
export default component.exports